<template>
  <div>
    <permission-group-list></permission-group-list>
  </div>
</template>

<script>

export default {
}
</script>


